<h1 *ngIf="!isAppMobile" class="dsd-b-30 dsd-color-font-secondary dsd-mb-xs">
  {{ 'caad.page-validation.sousTitre' | translate }}
</h1>
<h2 id="titreValidation" tabindex="-1" class="dsd-t-3 dsd-mb-md">
  {{ 'caad.page-validation.titre' | translate }}
</h2>

<dsd-container>
  <h3 class="dsd-t-4">
    {{ 'caad.page-validation.coordonnees.titre' | translate }}
  </h3>
  <p>
    <span class="libelle">{{ libelleAdresse | translate }}&nbsp;</span>
    <span class="valeur line-adresse">{{ adresseSaisie | adresse }}</span>
    <span class="valeur dsd-mt-xs" *ngIf="afficherDateChangement">
      <span>{{ 'caad.page-validation.coordonnees.aPartirDe' | translate }}&nbsp;</span>
      <span [innerHTML]="dateChangement | dateCustom"></span>
    </span>
  </p>
  <p>
    <span class="libelle">{{ 'caad.page-validation.coordonnees.courriel' | translate }}&nbsp;</span>
    <span class="valeur">{{ courriel || ('caad.page-validation.coordonnees.NonPrecisee' | translate) }}</span>
  </p>
  <p>
    <span class="libelle">{{ 'caad.page-validation.coordonnees.telephone.telephonePrincipal' | translate }}</span>
    <span class="valeur">{{ typeAppareilTelephone(telephonePrincipal) | translate }}</span>
    <span class="valeur">{{ telephonePrincipal | phone }}</span>
  </p>
  <p *ngIf="telephoneSecondaire">
    <span class="libelle">{{ 'caad.page-validation.coordonnees.telephone.telephoneSecondaire' | translate }}</span>
    <span class="valeur">{{ typeAppareilTelephone(telephoneSecondaire) | translate }}</span>
    <span class="valeur">{{ telephoneSecondaire | phone }}</span>
  </p>
  <p *ngIf="telephoneTravail">
    <span class="libelle">{{ 'caad.page-validation.coordonnees.telephone.telephoneTravail' | translate }}</span>
    <span class="valeur">{{ typeAppareilTelephone(telephoneTravail) | translate }}</span>
    <span class="valeur">{{ telephoneTravail | phone }}</span>
  </p>
  <!-- Bouton Modifier -->
  <dsd-button variant="compact" full-width="xs" (dsdButtonClick)="naviguerVersModifier()">
    {{ 'caad.button.modifier' | translate }}
  </dsd-button>
</dsd-container>

<dsd-container *ngIf="comptes.length > 0">
  <h3 class="dsd-t-4">
    {{ 'caad.page-validation.comptes.titre' | translate }}
  </h3>
  <p>{{ 'caad.page-validation.comptes.libellePartager' | translate }}</p>
  <app-validation-compte-vmd [comptes]="comptes" (comptesSelectionnes)="onComptesSelectionnes($event)">
  </app-validation-compte-vmd>
</dsd-container>

<div class="zone-btn">
  <!-- Bouton Confirmer -->
  <dsd-button variant="primary" full-width="xs" (dsdButtonClick)="naviguerVersConfirmation()">
    {{ 'caad.button.confirmer' | translate }}
  </dsd-button>
  <!-- Bouton Annuler -->
  <dsd-button full-width="xs" id="btnAnnuler" (dsdButtonClick)="annuler()">
    {{ 'caad.button.annuler' | translate }}
  </dsd-button>
</div>
